module.exports = __webpack_public_path__ + "img/sanfen.e3127aa4.png";